#import "../fragments/email-automation-status.graphql"

mutation EmailAutomationStatusManualStart($input: EmailAutomationStatusManualStartInput!) {
    emailAutomationStatusManualStart(input: $input) {
        emailAutomationStatus {
            ...EmailAutomationStatus
        }
    }
}
